import {MainTrainingCoverImageType, TrainingCoverImageModel} from "../../../../../../newShared/GQLTypes";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {downloadFileAction} from "../../../../../../newShared/actions/downloadFile";
import {Skeleton} from "@mui/material";

export const CoverImageView = ({cover, size}: {cover: TrainingCoverImageModel, size: 'list' | 'create' | 'exact' | 'preview' | 'template'}) => {
    const dispatch = useDispatch();
    const [image, setImage] = useState<string | null>(null);
    const isThumbnail = size === 'list' || size === 'template';

    useEffect(() => {
        if(cover.type === MainTrainingCoverImageType.FileId){
            dispatch(downloadFileAction({
                data: {
                    fileId: isThumbnail ? cover.thumbnail : cover.image,
                    fileName: cover.imageName,
                    dontSave: true
                },
                onSuccess: (request, response) => {
                    setImage('data:image/png;base64,' + response.file);
                }
            }))
        }else{
            setImage(isThumbnail ? cover.thumbnail : cover.image);
        }
        //eslint-disable-next-line
    }, [cover, size]);
    // const link = cover.type === MainTrainingCoverImageType.FileId ?
    //     `${APP_FILES_LINK}/files/base64/${size === 'thumbnail' ? cover.thumbnail : cover.image}`
    //     :
    //     size === 'thumbnail' ? cover.thumbnail : cover.image;

    const getImageStyleBySize = () => {
        switch (size){
            case "list": return {width: 60, height: 45};
            case "create": return {width: 124, height: 93};
            case "preview": return {width: 288, height: 216};
            case "exact": return {width: 400, height: 300};
            case "template": return {width: 180, height: 135};
        }
    }


    const style = getImageStyleBySize();
    return(
        <>
            {!image ?
                <Skeleton width={style.width} height={style.height}/>
                :
                <img src={image} style={{width: `${style.width}px`, height: `${style.height}px`, flexShrink: 0, borderRadius: '6px'}} alt={cover.imageName}/>
            }
        </>
    )
}